module.exports = __webpack_public_path__ + "img/Print-icon.a9fb52c7.svg";